import { Stack, Typography } from '@mui/material';

import { MapLayerIcon } from '@/components/display/MapLayerIcon';
import { I18N_DE } from '@/i18n/de';
import type { MapLayer } from '@/types/MapLayer';

interface DetailCardTitleProps {
  title: string;
  subtitle?: string;
  mapLayer: MapLayer;
}

export function DetailSidebarTitle({ title, subtitle, mapLayer }: DetailCardTitleProps) {
  return (
    <Stack alignItems="flex-start" display="flex" flexDirection="row" gap={2} py={4}>
      <MapLayerIcon mapLayer={mapLayer} size={32} />

      <Stack pr={2}>
        <Typography variant="h2">{title}</Typography>
        <Typography color="textSecondary" variant="body2">
          {subtitle ?? I18N_DE.MapLayer[mapLayer]}
        </Typography>
      </Stack>
    </Stack>
  );
}
